import { sort } from 'ramda';

export const sortDateDESC = (comparisons) => sort((a, b) => new Date(b.when).getTime() - new Date(a.when).getTime(), comparisons);
